import { css } from '@emotion/react';
import { darken } from 'polished';
import Mixin from '../../../util/mixin';
import { HoverFocus } from './_hover.mixin';


export class ListGroupItemVariant extends Mixin {
  style({$}, [state, background, color]) {
    return css`
      .list-group-item-${state} {
        color: ${color};
        background-color: ${background};

        &.list-group-item-action {
          ${new HoverFocus().include($, css`
            color: ${color};
            background-color: ${darken(0.05, background)};
          `)}

          &.active {
            color: ${$.white};
            background-color: ${color};
            border-color: ${color};
          }
        }
      }
    `;
  }
}
